import API, { API_URL } from 'api/API';

import { ApiResult, LatestData, LatestImage, ObsId, ObsInfo, ScamId } from 'libs/types';

interface GetAllObsDataApiResult extends ApiResult {
  obs_info: Record<ObsId, ObsInfo>;
  latest_data: Record<ObsId, LatestData>;
  latest_skycam: Record<ObsId, LatestImage>;
  latest_scam: Record<ObsId, Record<ScamId, LatestImage>>;
}

async function getAllObsDataApi(): Promise<GetAllObsDataApiResult> {
  const { data } = await API.get(`${API_URL.NOW.GET_ALL_OBS_DATA}`);

  return data;
}

export default getAllObsDataApi;
